import React from 'react';
import { ConfigProvider } from 'antd';
import { IntlProvider } from 'react-intl';
import { useSelector } from 'react-redux';
import { ThemeProvider } from 'styled-components';
import antdEn from 'antd/lib/locale-provider/en_US';
import antdPtBr from 'antd/lib/locale-provider/pt_BR';
import themes from '@iso/config/theme/theme.config';

export default function AppProvider({ children }) {
  // const { locale } = useSelector(state => state.LanguageSwitcher.language);
  // const currentAppLocale = AppLocale[locale];
  return (
    <ConfigProvider locale={antdPtBr}>
      <IntlProvider locale={'pt_BR'}>
        <ThemeProvider theme={themes.defaultTheme}>{children}</ThemeProvider>
      </IntlProvider>
    </ConfigProvider>
  );
}
